import Hls from 'hls.js'
import Image from 'next/image'
import { isMobile } from 'react-device-detect'
import { useFullscreen } from '../../useFullscreen'
import { useVideoScale } from '../../useVideoScale'
import { PlayerButton } from '../PlayerButton'
import { Volume } from '../Volume'
import { AutoPlay } from './AutoPlay'
import { FontSize } from './FontSize'
import { Quality } from './Quality'
import { Speed } from './Speed'
import { Subtitle } from './Subtitle'

type Props = {
  video: HTMLVideoElement
  hls: Hls | null
  vtts: {
    default: boolean
    url: string
    locale: string
    label: string
  }[]
  flashIcon: (type: string) => void
}

export const Menu = ({ video, hls, vtts, flashIcon }: Props) => {
  const { fullscreen, setFullscreen } = useFullscreen()
  const { videoScale } = useVideoScale()

  return (
    <div
      style={{
        width: '100%',
        padding: `${videoScale * 24}px ${videoScale * 32}px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      {!isMobile && (
        <div
          style={{
            pointerEvents: 'auto',
          }}
        >
          <Volume video={video} flashIcon={flashIcon} />
        </div>
      )}
      <div
        style={{
          width: '100%',
          height: `${videoScale * 52}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: `${videoScale * 48}px`,
          pointerEvents: 'none',
        }}
      >
        <div
          style={{
            pointerEvents: 'auto',
          }}
        >
          <Speed video={video} />
        </div>
        <div
          style={{
            pointerEvents: 'auto',
          }}
        >
          <Subtitle vtts={vtts} />
        </div>
        <div
          style={{
            pointerEvents: 'auto',
          }}
        >
          <FontSize />
        </div>
        {hls && (
          <div
            style={{
              pointerEvents: 'auto',
            }}
          >
            <Quality video={video} hls={hls} />
          </div>
        )}
        <div
          style={{
            pointerEvents: 'auto',
          }}
        >
          <AutoPlay />
        </div>
      </div>
      <div
        style={{
          width: `${videoScale * 52}px`,
          height: `${videoScale * 52}px`,
          flexShrink: 0,
          pointerEvents: 'auto',
        }}
      >
        {fullscreen ? (
          <PlayerButton onClick={() => setFullscreen(false)}>
            <Image
              src='/player/fullscreen_exit.png'
              alt='Exit Fullscreen'
              width={videoScale * 52}
              height={videoScale * 52}
            />
          </PlayerButton>
        ) : (
          <PlayerButton onClick={() => setFullscreen(true)}>
            <Image
              src='/player/fullscreen.png'
              alt='Fullscreen'
              width={videoScale * 52}
              height={videoScale * 52}
            />
          </PlayerButton>
        )}
      </div>
    </div>
  )
}
